export interface useProductLinkData {
    categoryId: string
    productId: string
}
export const useProductLink = (link: string): useProductLinkData => {
    const [categoryId, productId] = link.split('/')
    return { categoryId: categoryId ?? '', productId: productId ?? '' }
}
